import React from 'react';

import { Button, Text, VStack, theme } from '@squire/ui';

import { useScreenTranslations } from '@/hooks/useScreenTranslations';

import { styles } from './styles';
import type { CategoryUnavailableProps } from './types';

const CategoryUnavailable: React.FC<CategoryUnavailableProps> = ({
  level,
  onPress,
  testID = 'category-unavailable',
  style,
  ...props
}) => {
  const { t } = useScreenTranslations('CategoryUnavailable');

  return (
    <VStack
      flex
      space={theme.spacing[4]}
      centerHorizontal
      centerVertical
      style={[styles.container, style]}
      testID={testID}
      {...props}
    >
      <Text variant="l" color="textPrimary" align="center">
        {t('title')}
      </Text>
      <Text variant="m" color="textSecondary" align="center">
        {t('description')}
      </Text>
      <Button
        onPress={onPress}
        variant="primary"
        style={styles.button}
        testID={`${testID}-button`}
      >
        {t(level === 'l1' ? 'backToCategories' : 'backToSubcategories')}
      </Button>
    </VStack>
  );
};

CategoryUnavailable.displayName = 'CategoryUnavailable';

export { CategoryUnavailable };
